// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-portfolio-modal[data-v-0a60e0a7]{width:1110px}", ""]);
// Exports
module.exports = exports;
